<template lang="pug">
div
  div
    input(type='text', v-model='search', placeholder='recherche')
    button(@click='optionShow = !optionShow') option du tableau
    button(@click='exportCSV') exporter CSV
  .reportElemToShowOption(v-if='optionShow')
    p(
      :class='showItems.animatorName ? "active" : "none"',
      @click='showItems.animatorName = !showItems.animatorName'
    )
      | animateur
      input(type='checkbox', v-model='showItems.animatorName')
    p(
      :class='showItems.activitiesDetails ? "active" : "none"',
      @click='showItems.activitiesDetails = !showItems.activitiesDetails'
    )
      | activités
      input(type='checkbox', v-model='showItems.activitiesDetails')
    p(
      :class='showItems.appreciationRating ? "active" : "none"',
      @click='showItems.appreciationRating = !showItems.appreciationRating'
    )
      | note
      input(type='checkbox', v-model='showItems.appreciationRating')
    p(
      :class='showItems.appreciationDetails ? "active" : "none"',
      @click='showItems.appreciationDetails = !showItems.appreciationDetails'
    )
      | appréciation
      input(type='checkbox', v-model='showItems.appreciationDetails')
    p(
      :class='showItems.hadBugs ? "active" : "none"',
      @click='showItems.hadBugs = !showItems.hadBugs'
    )
      | bug rencontré
      input(type='checkbox', v-model='showItems.hadBugs')
    p(
      :class='showItems.bugsDetails ? "active" : "none"',
      @click='showItems.bugsDetails = !showItems.bugsDetails'
    )
      | détails des bugs
      input(type='checkbox', v-model='showItems.bugsDetails')
    p(
      :class='showItems.establishment ? "active" : "none"',
      @click='showItems.establishment = !showItems.establishment'
    )
      | établissement
      input(type='checkbox', v-model='showItems.establishment')
    p(
      :class='showItems.fromTime ? "active" : "none"',
      @click='showItems.fromTime = !showItems.fromTime'
    )
      | de
      input(type='checkbox', v-model='showItems.fromTime')
    p(
      :class='showItems.toTime ? "active" : "none"',
      @click='showItems.toTime = !showItems.toTime'
    )
      | à
      input(type='checkbox', v-model='showItems.toTime')
    p(
      :class='showItems.participantCount ? "active" : "none"',
      @click='showItems.participantCount = !showItems.participantCount'
    )
      | participants
      input(type='checkbox', v-model='showItems.participantCount')
    p(
      :class='showItems.remarks ? "active" : "none"',
      @click='showItems.remarks = !showItems.remarks'
    )
      | remarque
      input(type='checkbox', v-model='showItems.remarks')
    p(
      :class='showItems.type ? "active" : "none"',
      @click='showItems.type = !showItems.type'
    )
      | type
      input(type='checkbox', v-model='showItems.type')
  .reportElemToShow
    p(v-if='showItems.animatorName') animateur
    p(v-if='showItems.activitiesDetails') activités
    p(v-if='showItems.appreciationRating') note
    p(v-if='showItems.appreciationDetails') appréciation
    p(v-if='showItems.hadBugs') bug rencontré
    p(v-if='showItems.bugsDetails') détails des bugs
    p(v-if='showItems.establishment') établissement
    p(v-if='showItems.fromTime') de
    p(v-if='showItems.toTime') à
    p(v-if='showItems.participantCount') participants
    p(v-if='showItems.remarks') remarque
    p(v-if='showItems.type') type
  .reportsList
    div(v-for='(report, index) in reportsList', :key='index')
      report-item(
        :report='report',
        :showItems='showItems',
        :class='getClass(index)'
      )
</template>

<script>
import ReportItem from '@/components/generic/output/ReportItem'
import axios from 'axios'

let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

export default {
  data() {
    return {
      reportsList: [],
      search: '',
      showItems: {},
      countFalse: 0,
      optionShow: false,
    }
  },
  created() {
    let myLocalItem = window.localStorage.getItem('showItemsAdmin')
    if (!myLocalItem) {
      this.showItems = {
        animatorName: true,
        activitiesDetails: true,
        appreciationRating: true,
        appreciationDetails: true,
        hadBugs: true,
        bugsDetails: true,
        establishment: true,
        fromTime: true,
        toTime: true,
        participantCount: true,
        remarks: true,
        type: true,
      }
    } else {
      this.showItems = JSON.parse(myLocalItem)
    }
  },
  mounted() {
    this.getReportsList()
  },
  computed: {},
  methods: {
    async exportCSV() {
      await axios.get(`${BACK_END_PATH}/reports.csv`).then(r => {

        let fileURL = window.URL.createObjectURL(new Blob([r.data]))
        let fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'rapports-ateliers-declick.csv')
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    getClass(id) {
      return id % 2 ? 'odd' : 'even'
    },
    async getReportsList() {
      await axios.get(`${BACK_END_PATH}/allReports`).then(r => {
        // console.log(r)
        for (let rapport in r.data) {
          r.data[rapport].visible = true
        }
        this.reportsList = r.data
      })
    },
  },
  watch: {
    showItems: {
      handler: function (newValue) {
        this.countFalse = 0
        for (const val in newValue) {
          if (!newValue[val]) {
            this.countFalse++
          }
        }
        let reportElemToShow = document.querySelectorAll('.reportElemToShow p')
        let report = document.querySelectorAll('.report p')

        for (let i = 0; i < reportElemToShow.length; i++) {
          reportElemToShow[i].style.width =
            window.innerWidth / (11 - this.countFalse) + 'px'
        }
        for (let i = 0; i < report.length; i++) {
          report[i].style.width =
            window.innerWidth / (11 - this.countFalse) + 'px'
        }

        window.localStorage.setItem('showItemsAdmin', JSON.stringify(newValue))
      },
      deep: true,
    },
    search() {
      if (this.search.length > 0) {
        for (const rapport in this.reportsList) {
          this.reportsList[rapport].visible = false
          if (
            this.reportsList[rapport].name
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            this.reportsList[rapport].code.indexOf(this.search) >= 0
          ) {
            this.reportsList[rapport].visible = true
          } else {
            this.reportsList[rapport].visible = false
          }
        }
      } else {
        this.reportsList = this.reportsList.filter(r => {
          r.visible = true
          return r
        })
      }
    },
  },
  components: {
    ReportItem,
  },
}
</script>

<style >
.reportsList {
  height: 80vh;
  overflow: auto;
}
.reportElemToShow{
  background-color: rgb(66, 66, 66);
  color: #fff;
}
.reportElemToShow,
.reportElemToShowOption {
  /* background: white; */
  display: flex;
  justify-content: space-between;
}
/*
.report p {
   border-bottom: 1px solid;
}
*/
.reportElemToShowOption p {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reportElemToShowOption p,
.reportElemToShow p,
.report p {
  text-align: left;
  width: calc(100% / 12);
  padding: 5px;
}
.reportElemToShowOption .active,
.reportElemToShowOption .none {
  color: white;
  cursor: pointer;
}
.reportElemToShowOption .active {
  background: green;
}
.reportElemToShowOption .none {
  background: grey;
}
.reportsList .odd .report {
  background: #d0d0d0;
}
</style>
